import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTrailersForTerminal } from "redux/asssets/trailersSlice";


const WarehouseTrailers = () => {  
  const { loading, list = [], error } = useSelector((state) => state.trailers);
  const warehouse = useSelector((state) => state.warehouse.warehouse);

  const dispatch = useDispatch();

  useEffect(() => {
    if (warehouse) {
      dispatch(fetchTrailersForTerminal(warehouse));
    }
  }, [dispatch, warehouse]);

  return (
    <table className='warehouse-dashboard-table'>
      <thead>
        <tr>
          <th>Status</th>
          <th>Trailer #</th>
          <th>Comments</th>
        </tr>
      </thead>
      <tbody>
        {loading && (
          <tr>
            <td colSpan={3} className='py-2'>Loading trailers…</td>
          </tr>
        )}
        {error && !loading && (
          <tr>
            <td colSpan={3} className='py-2'>Failed to load trailers</td>
          </tr>
        )}
        {!loading && !error && list.map((trailer, index) => (
          <tr
            className={
              trailer.status === "Available"
                ? "warehouse-trailer available"
                : trailer.status === "Unavailable"
                  ? "warehouse-trailer unavailable"
                  : "warehouse-trailer"
            }
            key={index}
          >
            <td style={{ width: '10%' }} className='py-2'>{trailer.status}</td>
            <td style={{ width: '10%' }} className='py-2'>{trailer.trailer_no}</td>
            <td className='py-2'>
              <input
                type='text'
                className='form-control'
                value={trailer.comments || ""}
                readOnly
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default WarehouseTrailers
